<div
  #textElement
  (mouseover)="onMouseOver()"
  (mouseleave)="onMouseLeave()"
  class="ellipsis-text"
  [style.maxWidth.px]="maxWidth"
  [pTooltip]=" isTooltip && isHovered && text ? text : ''">
  {{ text }}
</div>
